export function formatPercents(value?: number, precision: number = 2, trimZeros: boolean = false) {
  if (value == null) value = 0;
  let formatted = value.toFixed(precision);
  if (trimZeros && formatted.includes('.')) {
    formatted = formatted.replace(/\.?0+$/, '');
  }
  return `${formatted}\xa0%`;
}
